import styled from "styled-components"
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
import PhoneRoundedIcon from '@material-ui/icons/PhoneRounded';
import MailOutlineRoundedIcon from '@material-ui/icons/MailOutlineRounded';

const Container = styled.div`
    display: flex;
    background-color: #241654;
`

const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
`
const Logo = styled.h1`
    font-size: 25px;
    margin-bottom: 30px;
    color: white;
    font-weight: 900;
`
const Description = styled.h2`
    margin: 20px 0;
    font-size: 18px;
    font-weight: 300;
    color: white;
`
const SocialContainer = styled.h2`
    display: flex;
    padding: 20px;
`

const Center = styled.div`
    flex: 1;
    padding: 20px;
    margin-left: 20px;
`
const Title = styled.h3`
    margin-bottom: 45px;
    color: white;
    font-weight: 700;
`
const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
`
const ListItem = styled.li`
    font-weight: 300;
    color: white;
    width: 50%;
    margin-bottom: 20px;
`

const Right = styled.div`
    flex: 1;
    padding: 20px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`
const ContactItem = styled.h3`
    font-weight: 200;
    color: white;
    width: 50%;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`

const Footer = () => {
    return (
        <Container>
            <Left> 
                <Logo>
                    LUGOS INTERNATIONAL S DE RL DE CV
                </Logo>
                <Description >
                    At the moment, not all functions 
                    and / or projects are available, so I ask you to please 
                    visit my site in the future, 
                    I will be more than happy to share the finished projects
                </Description>
                <SocialContainer> 
                    <img src="https://cdn-icons-png.flaticon.com/512/124/124010.png" alt="Facebook Logo" height="40px" style={{backgroundColor:"white", margin: "10px 20px"}} /> 
                    <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="Facebook Logo" height="40px" style={{borderRadius:"10px", backgroundColor:"white", margin: "10px 20px"}} /> 
                    <img src="https://cdn-icons-png.flaticon.com/512/1384/1384055.png" alt="Facebook Logo" height="40px" style={{borderRadius:"10px", backgroundColor:"white", margin: "10px 20px"}} /> 
                    <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="Facebook Logo" height="40px" style={{borderRadius:"10px", backgroundColor:"white", margin: "10px 20px"}} /> 
                    
                </SocialContainer>
            </Left>
            <Center>  
                <Title> Links for more info </Title>
                <List>
                    <ListItem>Home</ListItem>
                    <ListItem>Cart</ListItem>
                    <ListItem>Furniture Cleaning</ListItem>
                    <ListItem>Carpet cleaning</ListItem>
                    <ListItem>About us</ListItem>
                    <ListItem>Our mission</ListItem>
                    <ListItem>Terms and conditions</ListItem>
                </List>
            </Center>
            <Right>  
                <Title style={{marginBottom: "70px"}} >Contact</Title>
                <ContactItem >
                    <LocationOnRoundedIcon style={{margin: "5px"}} />
                    Cozumel, México
                </ContactItem>
                <ContactItem >
                    <PhoneRoundedIcon style={{margin: "5px"}} />
                    +52 987 116 47 48
                </ContactItem>
                <ContactItem >
                    <MailOutlineRoundedIcon  style={{margin: "5px"}}/>
                    lugosinternational@gmail.com
                </ContactItem>
            </Right>
        </Container>
    )
}

export default Footer
